const SUPPORTED_LOCALES = ['en', 'uk', 'de', 'lt'];

const screensByLocale = {
  en: [
    require('../assets/screens-web/en/1.png'),
    require('../assets/screens-web/en/2.png'),
    require('../assets/screens-web/en/3.png'),
    require('../assets/screens-web/en/4.png'),
    require('../assets/screens-web/en/5.png')
  ],
  uk: [
    require('../assets/screens-web/uk/1.png'),
    require('../assets/screens-web/uk/2.png'),
    require('../assets/screens-web/uk/3.png'),
    require('../assets/screens-web/uk/4.png'),
    require('../assets/screens-web/uk/5.png')
  ],
  de: [
    require('../assets/screens-web/de/1.png'),
    require('../assets/screens-web/de/2.png'),
    require('../assets/screens-web/de/3.png'),
    require('../assets/screens-web/de/4.png'),
    require('../assets/screens-web/de/5.png')
  ],
  lt: [
    require('../assets/screens-web/lt/1.png'),
    require('../assets/screens-web/lt/2.png'),
    require('../assets/screens-web/lt/3.png'),
    require('../assets/screens-web/lt/4.png'),
    require('../assets/screens-web/lt/5.png')
  ]
};

export function getLocaleScreens(locale) {
  const key = SUPPORTED_LOCALES.includes(locale) ? locale : 'en';
  return screensByLocale[key];
}

export default screensByLocale;
